export default __webpack_public_path__ + "static/media/91t.1f975139.jpg";